import { withInstall } from '@ll-plus/utils'

import TreeSearch from './src/tree-search.vue'

export const LlTreeSearch = withInstall(TreeSearch)
export default LlTreeSearch
export * from './src/config'

declare module 'vue' {
  export interface GlobalComponents {
    LlTreeSearch: typeof TreeSearch
  }
}
